var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManufacturing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.3,
    height: 19.3,
    viewBox: "0 0 19.3 19.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing",
    transform: "translate(-82.85 -207.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15866",
    "data-name": "Path 15866",
    d: "M83,276.185a.563.563,0,0,1,.616-.369c.258.012.517,0,.8,0,0-.076.009-.141.009-.207,0-.68.007-1.36,0-2.04a.6.6,0,0,1,.382-.612c.568-.27,1.136-.545,1.688-.847a.508.508,0,0,1,.79.482c-.025,1-.008,2-.008,3v.208H88.7v-.2c0-.68.008-1.36,0-2.04a.583.583,0,0,1,.366-.6c.557-.266,1.118-.527,1.654-.832a.525.525,0,0,1,.836.524c-.031.97-.008,1.941-.008,2.912v.234h1.43v-.2c0-.692,0-1.385,0-2.078a.539.539,0,0,1,.338-.54c.583-.284,1.159-.58,1.739-.869.435-.217.772-.01.773.475q0,1.494,0,2.987v.244h.825c.424,0,.6.173.6.594q0,1.494,0,2.987v.225h4.126c.47,0,.623.153.623.62,0,2.43,0,4.86,0,7.29a.632.632,0,0,1-.338.637H83.334L83,287.838Zm10.45,11.022h2.829V276.789H83.965V287.2H86.8v-.254q0-2.412,0-4.823c0-.438.166-.6.605-.6h5.415c.478,0,.633.154.633.631q0,2.412,0,4.823Zm-5.691-4.728v4.726h4.729v-4.726Zm9.5-1.9v6.63h3.774v-6.63Zm-10.943-4.767v-2.538c-.278.139-.533.272-.794.392a.22.22,0,0,0-.149.237c.008.506,0,1.013,0,1.52v.39Zm4.281-2.543c-.315.157-.6.3-.884.447a.2.2,0,0,0-.063.153c0,.612,0,1.224,0,1.836a.552.552,0,0,0,.017.1h.932C90.6,274.96,90.6,274.133,90.6,273.269Zm4.269,0c-.293.146-.555.282-.822.407a.2.2,0,0,0-.124.216c0,.5,0,1,0,1.5v.412h.944Z",
    transform: "translate(0 -61.431)",
    fill: "#161617",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15868",
    "data-name": "Path 15868",
    d: "M128.15,208.37a.96.96,0,0,1-.548.807,6.436,6.436,0,0,1-.684.28.26.26,0,0,0-.194.236.465.465,0,0,1-.511.427.484.484,0,0,1-.43-.533,1.069,1.069,0,0,1,.708-.976c.181-.079.376-.127.551-.214a.348.348,0,0,0,.165-.211.49.49,0,0,1,.508-.437C127.98,207.77,128.155,207.981,128.15,208.37Z",
    transform: "translate(-40.882 -0.007)",
    fill: "#161617",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15869",
    "data-name": "Path 15869",
    d: "M224.442,208.279a1,1,0,0,1-.575.906,6.191,6.191,0,0,1-.651.263.264.264,0,0,0-.2.249.46.46,0,0,1-.5.416.479.479,0,0,1-.437-.508,1.014,1.014,0,0,1,.587-.938c.208-.1.434-.175.651-.262.1-.04.18-.084.193-.217a.463.463,0,0,1,.512-.444A.479.479,0,0,1,224.442,208.279Z",
    transform: "translate(-132.901)",
    fill: "#161617",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15870",
    "data-name": "Path 15870",
    d: "M318.426,209.6a1.027,1.027,0,0,1,.65-.954c.189-.089.39-.152.587-.226a.251.251,0,0,0,.191-.238.46.46,0,0,1,.5-.424.477.477,0,0,1,.445.5,1.012,1.012,0,0,1-.564.934c-.212.111-.444.183-.667.273-.1.04-.185.077-.2.211a.464.464,0,0,1-.5.452A.479.479,0,0,1,318.426,209.6Z",
    transform: "translate(-224.972 -0.015)",
    fill: "#161617",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15877",
    "data-name": "Path 15877",
    d: "M426.31,529.508c-.155,0-.309.009-.463,0a.474.474,0,1,1,.031-.947q.444-.005.889,0a.474.474,0,1,1,.025.947C426.631,529.516,426.47,529.508,426.31,529.508Z",
    transform: "translate(-327.174 -306.566)",
    fill: "#161617",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15878",
    "data-name": "Path 15878",
    d: "M426.331,485.854c.16,0,.321-.005.481,0a.471.471,0,0,1,.463.461.462.462,0,0,1-.447.474c-.339.011-.679.012-1.018,0a.448.448,0,0,1-.43-.466.46.46,0,0,1,.452-.468C426,485.848,426.164,485.855,426.331,485.854Z",
    transform: "translate(-327.178 -265.759)",
    fill: "#161617",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturing);
export default __webpack_public_path__ + "static/media/manufacturing.5c6ec0114b07fb7e6862501870ebd914.svg";
export { ForwardRef as ReactComponent };